import React, { FC, useEffect } from 'react';
import { useAuthProvider } from 'utils/api/useAuthProvider';
import { logOutAndCleanUp } from '../../utils/models/User';
import Loading from '../Widgets/Loading';

const Logout: FC = () => {
  const { logout } = useAuthProvider();

  useEffect(() => {
    logOutAndCleanUp(logout);
  }, [logout]);

  return <Loading />;
};

export default React.memo(Logout);
